// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const pig = defineModel({
  id: "pig",
  scale: 2.84, // real-world size correction (see Model.scale)
  batchId: "future",
  name: "Pig",
  tags: ["creature","pig","low-poly","age-of-mcp","future"],
  summary: "A pig — meat and lard, fattened cheaply on scraps.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.1,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.011, 0.009, 0.04, 5), color: "#c2787e", position: [0.045, 0.02, 0.035] },
      { geometry: new THREE.CylinderGeometry(0.011, 0.009, 0.04, 5), color: "#c2787e", position: [0.045, 0.02, -0.035] },
      { geometry: new THREE.CylinderGeometry(0.011, 0.009, 0.04, 5), color: "#c2787e", position: [-0.045, 0.02, 0.035] },
      { geometry: new THREE.CylinderGeometry(0.011, 0.009, 0.04, 5), color: "#c2787e", position: [-0.045, 0.02, -0.035] },
      { geometry: new THREE.IcosahedronGeometry(0.058, 0), color: "#e89aa0", position: [0, 0.075, 0], scale: [1.55, 1, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.034, 0), color: "#f2acb2", position: [0.072, 0.07, 0], scale: [1, 1, 1.05] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.012, 8), color: "#dd848c", position: [0.1, 0.066, 0], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#7a4248", position: [0.107, 0.07, 0.007] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#7a4248", position: [0.107, 0.07, -0.007] },
      { geometry: new THREE.ConeGeometry(0.014, 0.024, 4), color: "#e89aa0", position: [0.064, 0.095, 0.024], rotation: [0.5, 0, 0.6] },
      { geometry: new THREE.ConeGeometry(0.014, 0.024, 4), color: "#e89aa0", position: [0.064, 0.095, -0.024], rotation: [-0.5, 0, 0.6] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#201418", position: [0.09, 0.082, 0.016] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#201418", position: [0.09, 0.082, -0.016] },
      { geometry: new THREE.TorusGeometry(0.012, 0.0035, 5, 10, 5.026548), color: "#f2acb2", position: [-0.062, 0.09, 0], rotation: [0, 1.570796, 0.4] },
    ],
  animations: [],
});
